import React from 'react'
import { connect } from 'react-redux'
import SweetAlert from 'sweetalert-react'
import { eventAlertShowed } from '../../../actions'

class EventShower extends React.Component {

  render = () => {
    if (this.props.events.length > 0) {
      const event = this.props.events[0]
      return (<SweetAlert
        show={event.show}
        title={event.title}
        text={event.text}
        showConfirmButton={event.showConfirmButton}
        onConfirm={() => { this.props.eventAlertShowed() }}
        confirmButtonColor={event.confirmButtonColor}
        imageUrl={event.imageUrl}
        imageSize="250x250"
      />)
    }
    return (<SweetAlert title="" show={false} />)
  }

}

EventShower.propTypes = {
  events: React.PropTypes.arrayOf(
    React.PropTypes.shape({
      show: React.PropTypes.bool,
      title: React.PropTypes.string,
      text: React.PropTypes.string,
      confirmButtonColor: React.PropTypes.string,
      showConfirmButton: React.PropTypes.bool,
      imageUrl: React.PropTypes.string,
    }),
  ),
  eventAlertShowed: React.PropTypes.func,
}

const mapStateToProps = state => ({
  events: state.user.userEvents,
})

const mapDispatchToProps = dispatch => ({
  eventAlertShowed: () => dispatch(eventAlertShowed()),
})

export default connect(mapStateToProps, mapDispatchToProps)(EventShower)



// WEBPACK FOOTER //
// ./src/components/Layout/EventShower/index.jsx